module.exports = __webpack_public_path__ + "img/reward13.593caa91.png";